import { v4 as uuid } from "uuid";

export function getDeviceId() {
  let id = localStorage.getItem("device_id");
  if (!id) {
    id = uuid();
    localStorage.setItem("device_id", id);
  }
  return id;
}